import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { c as config } from './config.js';
import { d as defineCustomElement$2 } from './payment-method-form.js';

const CardForm = /*@__PURE__*/ proxyCustomElement(class CardForm extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.cardFormReady = createEvent(this, "cardFormReady", 7);
        this.ready = createEvent(this, "ready", 7);
        this.cardFormTokenized = createEvent(this, "cardFormTokenize", 7);
        this.cardFormValidated = createEvent(this, "cardFormValidate", 7);
        this.validationMode = undefined;
        this.iframeOrigin = config.iframeOrigin;
        this.singleLine = false;
        this.internalStyleOverrides = undefined;
    }
    readyHandler(event) {
        console.warn(`The 'cardFormReady' event is deprecated in the next major release and will be renamed to 'ready'`);
        this.cardFormReady.emit(event);
        this.ready.emit(event);
    }
    tokenizeHandler(event) {
        console.warn(`The 'cardFormTokenize' event is deprecated in the next major release. Please refer to the documentation for the migration process and alternative approach. This method will be removed in the future.`);
        this.cardFormTokenized.emit(event);
    }
    validateHandler(event) {
        console.warn(`The 'cardFormValidate' event is deprecated in the next major release. Please refer to the documentation for the migration process and alternative approach. This method will be removed in the future.`);
        this.cardFormValidated.emit(event);
    }
    /**
     *  Makes a tokenization request to the iframe
     */
    async tokenize(...args) {
        if (!this.childRef) {
            throw new Error('Cannot call tokenize');
        }
        return this.childRef.tokenize(...args);
    }
    /**
     *  Runs a validation on the form and shows errors if any
     */
    async validate() {
        if (!this.childRef) {
            throw new Error('Cannot call validate');
        }
        return this.childRef.validate();
    }
    /**
     *  Manually resizes the iframe to fit the contents of the iframe
     *  @deprecated This method will be removed in future releases.
     */
    async resize() {
        console.warn(`The 'resize' method is deprecated and will be removed in the next major release. Please refer to the documentation for the migration process and alternative approach.`);
        if (!this.childRef) {
            throw new Error('Cannot call validate');
        }
        return this.childRef.resize();
    }
    render() {
        return (h("justifi-payment-method-form", { ref: el => {
                if (el) {
                    this.childRef = el;
                }
            }, "iframe-origin": this.iframeOrigin, "payment-method-form-type": "card", "single-line": this.singleLine, "payment-method-form-ready": this.cardFormReady, "payment-method-form-validate": this.cardFormValidated, "payment-method-form-tokenize": this.cardFormTokenized, "payment-method-form-validation-mode": this.validationMode || 'onSubmit' }));
    }
}, [0, "justifi-card-form", {
        "validationMode": [1025, "validation-mode"],
        "iframeOrigin": [1025, "iframe-origin"],
        "singleLine": [4, "single-line"],
        "internalStyleOverrides": [32],
        "tokenize": [64],
        "validate": [64],
        "resize": [64]
    }, [[0, "paymentMethodFormReady", "readyHandler"], [0, "paymentMethodFormTokenized", "tokenizeHandler"], [0, "paymentMethodFormValidated", "validateHandler"]]]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-card-form", "justifi-payment-method-form"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-card-form":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CardForm);
            }
            break;
        case "justifi-payment-method-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const JustifiCardForm = CardForm;
const defineCustomElement = defineCustomElement$1;

export { JustifiCardForm, defineCustomElement };
